import { Link } from "react-router-dom";
import { typeCategories } from "@/lib/videoService";

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 -mt-14 relative z-20">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {typeCategories.map((category, i) => (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors animate-fade-up"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <span className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-50 text-primary-600 shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${category.icon} text-2xl md:text-3xl`} />
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-base md:text-lg font-semibold text-foreground-950">
                {category.name}频道
              </span>
              <span className="block mt-1 text-xs md:text-sm text-foreground-500 line-clamp-2">
                {category.desc}
              </span>
            </span>
            <i className="ri-arrow-right-line text-foreground-400 ml-auto shrink-0 group-hover:text-primary-500 group-hover:translate-x-1 transition-all" />
          </Link>
        ))}
      </div>
    </section>
  );
}